import { TokenManager } from "utils/security/securityUtil";
import { postAccountUserLogout, postTokenReissue } from "./accountApi";
import { v2AxiosInstance } from "./indexApi";

let tokenPromise = null;

export const v2SetupAxiosInterceptors = (
  addRequestToQueue,
  clearQueue,
  getFailedRequestsQueue
) => {
  v2AxiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const { code } = error.response?.data?.data || {};

      switch (code) {
        case "7802":
          if (originalRequest._retry) {
            return Promise.reject(error);
          }
          originalRequest._retry = true;

          addRequestToQueue(originalRequest); // 큐에 추가

          if (!tokenPromise) {
            tokenPromise = postTokenReissue()
              .then(({ success }) => {
                if (success) {
                  tokenPromise = null;
                  const retryRequests = [...getFailedRequestsQueue()];
                  clearQueue();
                  return Promise.all(
                    retryRequests.map((req) => v2AxiosInstance(req))
                  );
                }
                throw new Error("Token reissue failed");
              })
              .catch((refreshError) => {
                tokenPromise = null;
                clearQueue();
                throw refreshError;
              });
          }

          try {
            await tokenPromise;
            return v2AxiosInstance(originalRequest);
          } catch (refreshError) {
            return Promise.reject(refreshError);
          }
        case "7801":
        case "7803":
        case "7804":
        case "7805":
        case "7806":
        case "7807":
        case "7000": // 사이트 계정 정보 없을때
          // 이미 로그아웃 진행 중이면, 기존 요청을 기다렸다가 실행
          if (!tokenPromise) {
            tokenPromise = postAccountUserLogout()
              .then(({ success }) => {
                if (success) {
                  // addRequestToQueue(originalRequest);
                  TokenManager.clearAccessToken();
                }
              })
              .catch((refreshError) => {
                throw refreshError;
              })
              .finally(() => {
                tokenPromise = null;
              });
          }
          return Promise.reject(error);

        default:
          return Promise.reject(error);
      }
    }
  );
};
